import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'ssg-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.less']
})
export class CurrencyComponent implements OnInit {
  stateChanged = new EventEmitter<any>();
  private _amount: number;
  @Input() showFullAmount: boolean;
  @Input() inline: boolean;
  private _align: string;

  constructor() {
  }

  ngOnInit() {
  }

  get format(): string {
    return this.showFullAmount ? '1.2-2' : '1.0-2';
  }

  get amount(): number {
    return this._amount;
  }

  @Input() set amount(value: number) {
    this._amount = value;
    this.stateChanged.emit();
  }

  get align(): string {
    return this._align;
  }

  @Input() set align(value: string) {
    this._align = value;
    this.stateChanged.emit();
  }

  getAlignmentClass(): string {
    if (this.align === 'left') {
      return 'currency-left';
    } else {
      return 'currency-right';
    }
  }
}
